var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"previewImage",class:{ hover: _vm.hover, hide: _setup.hide },on:{"click":_setup.handleClick}},[_c('img',{attrs:{"src":_setup.getAssetsUrl(_vm.src),"alt":""},on:{"error":_setup.handleError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }